import { processSteps } from "@/components/data/process";

const Process = () => {
  return (
    <section id="processo" className="py-12 lg:py-20 bg-background scroll-mt-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 lg:mb-4">
            Entenda como funciona o processo de homologação de Divórcio Estrangeiro
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-8 relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-border" style={{ width: "calc(100% - 8rem)", marginLeft: "4rem" }} />
          
          {processSteps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative">
                <div className="flex flex-col items-center text-center">
                  <div className="relative z-10 w-16 h-16 lg:w-20 lg:h-20 rounded-full bg-accent flex items-center justify-center mb-4 lg:mb-6 shadow-lg">
                    <Icon className="w-8 h-8 lg:w-10 lg:h-10 text-accent-foreground" />
                  </div>
                  <h3 className="text-lg lg:text-xl font-bold text-foreground mb-2 lg:mb-3">
                    {step.title}
                  </h3>
                  <p className="text-sm lg:text-base text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
